module.exports = __webpack_public_path__ + "static/media/empty-reviews.2dbfb869.svg";